angular.module( 'acme.view.application.passes.create.series.modals.remove', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.create.series.modals.remove.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesCreateSeriesModalsRemove = {
        name: 'application.passes.create.series.modals.remove',
        url: '/passes/create/series/modals/remove',
        views: {
          "main": {
            controller: 'PassesCreateSeriesModalsRemoveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/series/modals/remove/remove.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(passesCreateSeriesModalsRemove);
});
